module.exports = __webpack_public_path__ + "static/media/YB5F01_4.a9585848.jpg";